import { SET_ENTITY_MANAGER_FORMS } from '@state-management/constants';

export class SetEntityManagerFormsAction {
  readonly type = SET_ENTITY_MANAGER_FORMS;
  constructor(public readonly payload?: { data: unknown[] }) {}
}
